import { render } from "./PendingTarget.vue?vue&type=template&id=5bb8c46d&ts=true"
import script from "./PendingTarget.vue?vue&type=script&lang=ts"
export * from "./PendingTarget.vue?vue&type=script&lang=ts"

import "./PendingTarget.vue?vue&type=style&index=0&id=5bb8c46d&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__